import { render } from "./loc-picker.vue?vue&type=template&id=f53ba7ae&scoped=true"
import script from "./loc-picker.vue?vue&type=script&lang=js"
export * from "./loc-picker.vue?vue&type=script&lang=js"

import "./loc-picker.vue?vue&type=style&index=0&id=f53ba7ae&lang=scss&scoped=true"

import exportComponent from "D:\\code\\sns\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f53ba7ae"]])

export default __exports__